import React from 'react';

const Dashboard = () => {
  return (
    <div className="admin-page">
      <h1>Admin Dashboard</h1>
      <p>Welcome to the HCC App Management Dashboard.</p>
      <div className="admin-stats-grid">
        <div className="stat-card">
          <h3>Total Users</h3>
          <p>--</p>
        </div>
        <div className="stat-card">
          <h3>Upcoming Events</h3>
          <p>--</p>
        </div>
        <div className="stat-card">
          <h3>Prayer Requests</h3>
          <p>--</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
